import React, { useState, useEffect } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";

export default function MultiFields({ handleMultiSelectChange }) {
  const [fieldLists, setFieldLists] = useState(() => {
    const savedFields = localStorage.getItem("fieldLists");
    return savedFields ? JSON.parse(savedFields) : [{ baseURL: "", environment: "" }];
  });

  useEffect(() => {
    localStorage.setItem("fieldLists", JSON.stringify(fieldLists));
    handleMultiSelectChange(fieldLists);
  }, [fieldLists]);

  const handleInputChange = (e, i) => {
    const { name, value } = e.target;
    const list = [...fieldLists];
    list[i][name] = value;
    setFieldLists(list);
  };

  const handleAddClick = () => {
    setFieldLists((prev) => [...prev, { baseURL: "", environment: "" }]);
  };

  const handleRemoveClick = (i) => {
    const list = [...fieldLists];
    const remove = list.filter((_, indexFilter) => indexFilter !== i);
    setFieldLists(remove);
  };

  return (
    <>
      <div>
        {fieldLists.map((field, i) => (
          <div key={i} className="mb-4 relative">
            <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">
              Set your Domain
            </label>
            <div className="mb-2">
              <input
                name="baseURL"
                type="text"
                placeholder="your-domain.com"
                onChange={(e) => handleInputChange(e, i)}
                value={field.baseURL}
                required
                className="mt-1 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <div className="mb-2">
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-1">
                Enter your Environment
              </label>
              <input
                name="environment"
                type="text"
                placeholder="Testing or Production"
                onChange={(e) => handleInputChange(e, i)}
                value={field.environment}
                required
                className="mt-1 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <div className="flex justify-end space-x-2">
              {fieldLists.length - 1 === i && fieldLists.length < 5 && (
                <MdAddCircleOutline
                  className="text-gray-500 text-2xl cursor-progress"
                  onClick={handleAddClick}
                />
              )}
              {fieldLists.length !== 1 && (
                <IoIosCloseCircleOutline
                  className="text-gray-500 text-2xl cursor-progress"
                  onClick={() => handleRemoveClick(i)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
